import React from 'react';


export default function DemoInstructions() {
    return (
      <div className="container mt-5 py-5">
        <div className="row d-flex">
          <h2 className="mb-4">Demo instructions.</h2>
            <ul>
              <li>Create an email with your desired content</li>
              <li>Send the email to <a href="mailto:create@linkoln.email">create@linkoln.email</a></li>
              <li>Receive a Linkoln Email link to your content.</li>
            </ul>
        </div>
      </div>
    );
}
